import { convertInviteUrlToCurrentHost } from "@/utils/countryConfigUtils";

export interface InviteLinkData {
  inviteUrl?: string;
  inviteCode?: string;
}

export interface InviteShareOptions {
  shareSpin?: boolean;
  inviteData?: InviteLinkData;
}

export const buildInviteLink = (
  data: InviteLinkData | undefined,
  shareSpin = false
): string => {
  if (
    typeof data?.inviteUrl !== "string" ||
    typeof data.inviteCode !== "string" ||
    !data.inviteCode.trim()
  )
    return "";

  try {
    const url = new URL(convertInviteUrlToCurrentHost(data.inviteUrl));
    if (url.protocol !== "https:" && url.protocol !== "http:") return "";
    url.searchParams.set("rid", data.inviteCode);
    if (shareSpin) {
      url.searchParams.set("shareSpin", "true");
    } else {
      url.searchParams.delete("shareSpin");
    }
    return url.toString();
  } catch {
    return "";
  }
};
